export const list = (dispatch, apiClient) => apiClient
  .call({ endpoint: 'rawMaterial/list' })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_SET', payload: res.data });
    return res;
  });

export const list2 = (dispatch, apiClient, query, skipId) => apiClient
  .call({ endpoint: 'rawMaterial/list2', data: { query, skipId } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_SET', payload: res.data.results });
    return res;
  });

export const find = (dispatch, apiClient, query) => apiClient
  .call({ endpoint: 'rawMaterial/find', data: { query } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_SET', payload: res.data });
    return res;
  });

export const create = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'rawMaterial/new', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_SET', payload: res.data });
    return res;
  });

export const update = (dispatch, apiClient, id, data) => apiClient
  .call({ endpoint: 'rawMaterial/update', data: { ...data, id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_SET', payload: res.data });
    return res;
  });

export const get = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'rawMaterial/get', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_SET', payload: res.data.rawMaterial });
    dispatch({ type: 'RAW_MATERIAL_STOCK_SET', payload: res.data.rawMaterialStock });
    return res;
  });

export const remove = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'rawMaterial/remove', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_SET', payload: res.data });
    return res;
  });

export const move2 = (dispatch, apiClient, rawMaterials, from, to) => apiClient
  .call({ endpoint: 'rawMaterial/move2', data: { rawMaterials, from, to } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_SET', payload: res.data.rawMaterialStock });
    return res;
  });

export const verifyStock = (dispatch, apiClient, rawMaterials, location, locationDiff) => apiClient
  .call({ endpoint: 'rawMaterial/verifyStock', data: { rawMaterials, location, locationDiff } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    return res;
  });

export const getStock = (dispatch, apiClient, location) => apiClient
  .call({ endpoint: 'rawMaterial/getStock', data: { location } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_STOCK_SET', payload: res.data });
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/rawMaterial.js